module.exports = __webpack_public_path__ + "img/ic_fluent_sub_grid_24_regular.edb1bda8.svg";